import type { CondensateViscosityCalculator } from "../../d";
import { deadCondensateViscosityCalculator } from "./deadCondensateViscosityCalculator";
import { saturatedCondensateViscosityCalculator } from "./saturatedCondensateViscosityCalculator";
import { underSaturatedCondensateViscosityCalculator } from "./underSaturatedCondensateViscosityCalculator";

// PVT!BJ54:BJ68 — the Beggs and Robinson chain fed condensate SG, Rs and dew point
const condensateViscositiesCalculator: CondensateViscosityCalculator = {
  deadCondensateViscosityCalculator,
  saturatedCondensateViscosityCalculator,
  underSaturatedCondensateViscosityCalculator
};

export { condensateViscositiesCalculator };
